var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "grid-section",
    style: [_vm.styles.backgroundColor && {
      backgroundColor: _vm.styles.backgroundColor
    }, _vm.styles.color && {
      color: _vm.styles.color
    }]
  }, [_c('div', {
    staticClass: "grid-container",
    style: _vm.isMobile ? _vm.mobileStyles : _vm.styles
  }, _vm._l(_vm.columns, function (col, index) {
    return _c('SanityBlockContent', {
      key: index,
      staticClass: "grid-col",
      class: `grid-${col.content[0]._type}`,
      style: _vm.isMobile ? [col.mobileStyles, {
        backgroundColor: col.styles && col.styles.backgroundColor,
        color: col.styles && col.styles.color
      }] : col.styles,
      attrs: {
        "blocks": col.content[0]._type === 'freeform' ? col.content[0].content : col.content
      }
    });
  }), 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };